const personTypeId = $(".dropdown-menu input[name=person_type]").val();

if(personTypeId){
  console.log("personTypeID" + personTypeId);
  $(".price-content").each(function (){
    const productPrice = $(this).attr(`data-price-group-${personTypeId}`);
    const bestProductPrice = $(this).attr(`data-best-price-group-${personTypeId}`);
    const productPriceOf = $(this).attr(`data-price-of-group-${personTypeId}`);
    
    if(bestProductPrice){
      $(this).find(".price .value").text(bestProductPrice);
    }

    if(productPrice){
      $(this).find(".price.credit .value").text(productPrice);
    }
    
    $(this).find(".parcels, .parcel").addClass("d-none");

    if(productPriceOf){
      $(this).find(".price-of").removeClass("d-none").find(".value").text(productPriceOf);
    }
  })
}